export const PROVIDER_MODEL_KEYS = ["gpt-image-2", "gpt-image-2.5", "nano-banana-2", "seedance-2.0", "seedance-2.5"] as const;
export type ProviderModelKey = typeof PROVIDER_MODEL_KEYS[number];
export type Provider = "fal" | "kie";
export const PROVIDER_MODEL_LABELS: Record<ProviderModelKey, string> = {
  "gpt-image-2": "GPT Image 2",
  "gpt-image-2.5": "GPT Image 2.5",
  "nano-banana-2": "Nano Banana 2",
  "seedance-2.0": "Seedance 2.0",
  "seedance-2.5": "Seedance 2.5",
};
export const PROVIDER_DEFAULTS: Readonly<Record<ProviderModelKey, Provider>> = {
  "gpt-image-2": "fal", "gpt-image-2.5": "fal", "nano-banana-2": "fal", "seedance-2.0": "fal", "seedance-2.5": "kie",
};
export type ProviderSetting<T extends string> = {
  value: T; updatedBy: string | null; updatedAt: Date | null; version: number;
};
export type ProviderRoutingSettings = {
  models: Record<ProviderModelKey, ProviderSetting<Provider>>;
  forceFal: ProviderSetting<"on" | "off">;
};
